const ElaborationTasks = ({elaboration})=>{
    const getStatusColor = (status)=>{
        let statusColor = '';
        let statusText = '';
        switch (status){
            case 'queued':
                statusColor = 'orange';
                statusText = 'IN ATTESA';
                break;
            case 'pending':
                statusColor = 'orange';
                statusText = 'IN ATTESA';
                break;
            case 'processing':
                statusColor = 'blue';
                statusText = 'IN ELABORAZIONE';
                break;
            case 'in_progress':
                statusColor = 'blue';
                statusText = 'IN ELABORAZIONE';
                break;
            case 'completed':
                statusColor = 'green';
                statusText = 'COMPLETATO';
                break;
            case 'failed':
                statusColor = 'red';
                statusText = 'FALLITO';
                break;
            default:
                statusColor = 'black'
                statusText = status.toUpperCase();
        }
        return <span style={{ color: statusColor }}>{statusText}</span>;
    }

    return (
        <div>
            {
                elaboration &&
                elaboration.results.map((task, index)=>(
                    <ul key={index}>
                        <li>{index + 1 } - stato: {getStatusColor(task.status)} | file output : {task.output_file_path}</li>
                    </ul>
                ))
            }
        </div>
    )
}

export default ElaborationTasks